import { render, staticRenderFns } from "./GetVerificationID.vue?vue&type=template&id=300c0642&scoped=true&"
import script from "./GetVerificationID.vue?vue&type=script&lang=js&"
export * from "./GetVerificationID.vue?vue&type=script&lang=js&"
import style0 from "./GetVerificationID.vue?vue&type=style&index=0&id=300c0642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300c0642",
  null
  
)

export default component.exports